var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"smartTown"}},[_c('div',{staticClass:"title"},[_vm._v("关于支持博鳌乐城国际医疗旅游先行区发展的措施(试行)")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("为推动博鳌乐城国际医疗旅游先行区(以下简称先行区)高质量发展，加快推进海南自由贸易试验区、中国特色自由贸易港建设，现制定如下措施。")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.toLink()}}},[_vm._v("查看详情")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43dfdb1d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/news7.vue
// module id = null
// module chunks = 